<template>
    <div>
        <h1>
            Hi {{ needToSignIn ? '' : this.authStore.currentUser?.email }}!
            {{ needToSignIn ? 'Please sign in.' : 'Welcome to ecParcel!!' }}
        </h1>
    </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from 'vue';
import { useAuthStore } from '../stores/AuthStore';

export default defineComponent({
    name: 'Home',

    setup() {
        const authStore = useAuthStore();
        const needToSignIn = ref(true);

        const checkAuthState = async () => {
            const authenticated = await authStore.isAuthenticated();
            needToSignIn.value = !authenticated;
        };

        onMounted(() => {
            checkAuthState();
        });

        return {
            authStore,
            needToSignIn
        };
    }
});
</script>
